var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.isIos
    ? _c("div", [
        _c("div", {
          staticStyle: { width: "100vw", background: "transparent" },
          style: { height: _vm.$store.state.bankHeight + "px" }
        }),
        _c("div", {
          staticStyle: { width: "100vw", background: "transparent" },
          style: { height: _vm.$store.state.iosHeight + "px" }
        })
      ])
    : _c("div", [
        _c("div", {
          staticStyle: { width: "100vw", background: "transparent" },
          style: { height: _vm.$store.state.bankHeight + "px" }
        })
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c0e222f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c0e222f","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottomFixedBlank/bottomFixedBlank.vue
// module id = 678
// module chunks = 25